// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1596":"88d5bafb","5061":"707a1eaa","8905":"05bc6308","8975":"707a1eaa"}[chunkId] + ".chunk.css";
};